export default {
    addDashboard: "Adicionar dashboard",
    saveDashboard: "Dashboard salvo com sucesso",
    dashboardButtons: {
        filters: "Filtros",
        zoom: "Zoom",
        remove: "Remover",
        move: "Mover",
        edit: "Editar",
        save: "Salvar",
        close: "Fechar",
        addGraph: "Adicionar componente",
        configure: "Configurar",
    },
    deleteModal: {
        title: 'Eliminar Dashboard',
        body: 'Tem certeza de que deseja eliminar o dashboard "{dashboardName}"?',
        cancel: 'Cancelar',
        confirm: 'Confirmar',
    },
    filters: {
        title: 'Escolha os filtros a aplicar',
        labels: {
            generalFilters: 'Filtros gerais',
            dashboardFilters: 'Filtros do dashboard',
            graphFilters: 'Filtros individuais',
            noFilters: 'Nenhum filtro aplicado',
        },
        addFilter: 'Adicionar filtro',
        addedFilter: 'Este filtro já foi adicionado',
    },
    editNameModal: {
        title: 'Renomear gráfico',
        rename: 'Renomenar',
    },
    graphTitles: {
        VARIANTS: 'Variantes classificadas',
        VARIANTSFREQDUR: 'Variantes por frequência e duração',
        TRANSITIONS: 'Transições classificadas',
        ACTIVITIES: 'Atividades classificadas',
        ATTRIBUTE: 'Informações de atributos',
        OTHERS: 'Frequência e duração',
    },
    graphSubtitles: {
        FREQUENCY: 'Frequência',
        frequencyvsaverage: 'Variantes por frequência e duração',
        DURATION_AVG: 'Duração média',
        DURATION_MAX: 'Duração máxima',
        DURATION_MIN: 'Duração mínima',
        DURATION_STD: 'Desvio padrão do tempo',
        attributeInformation: 'Análise padrão',
        FREQUENCY_AND_DURATION: 'Frequência e duração',
    },
    filterTags: {
        own: "Gráfico",
        dashboard: "Dashboard",
        general: "Geral",
    },
}
